import { ApiEndpoints } from '../constants/ApiActions';
import { type GraphQLRequestParams, type GraphQLSchema, GraphQL } from '../graphql';
import Api from '../lib/Api';
import { getCurrentClientVersion } from '../lib/ClientInfoUtils';

interface INormalizerOutput {
  entities?: GraphQLSchema | unknown;
  result: $TSFixMe;
}

export function graphQLRequest<V, A>({
  query,
  variables,
  operationKeyName,
  actionParams,
}: GraphQLRequestParams<V, A>): () => Promise<INormalizerOutput | unknown> {
  const content = {
    query,
    // Per request from CENABL-6864, we are appending Web to the operationName for ease of filtering queries.
    operationName: `${GraphQL.Constants.OperationNames[operationKeyName]}Web`,
    ...(variables && { variables: JSON.stringify(variables) }),
  };

  // TODO WEBCA-2159: apply more specific api typing for error cases
  return (): Promise<INormalizerOutput | unknown> => {
    return Api.apiRequest({
      headers: {
        'x-featureflags': 'SPS',
        'apollographql-client-name': 'web',
        'apollographql-client-version': getCurrentClientVersion(),
      },
      endpoint: ApiEndpoints.GRAPHQL,
      graphQLOperationKeyName: operationKeyName,
      content,
      actionParams,
    });
  };
}
